var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-end" },
    [
      _c(_setup.ConfirmationModal, {
        attrs: {
          value: _setup.modal.show,
          title: _setup.modal.title,
          "action-verb": _setup.modal.actionVerb,
          "hide-cancel":
            !!_setup.modal.conflictError || _setup.modal.hideCancel,
        },
        on: {
          ok: function ($event) {
            _setup.modal.action?.()
          },
          cancel: _setup.toggleModal,
        },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                !_setup.modal.conflictError
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_setup.modal.description) },
                    })
                  : _c("div", [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_setup.modal.conflictError.errorText)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(
                          _setup.modal.conflictError.list,
                          function (item) {
                            return _c("li", { key: item.id }, [
                              _c("strong", [_vm._v("Id:")]),
                              _vm._v(" " + _vm._s(item.id)),
                              _c("br"),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Name:")]),
                              _vm._v(
                                " " +
                                  _vm._s(item.name) +
                                  "\n                    "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(_setup.CSelect, {
        staticClass: "flex-fill",
        attrs: {
          label: _vm.label,
          value: _setup.props.value,
          searchable: "",
          options: _setup.fontList,
          "always-open": _setup.props.open,
          disabled: _vm.disabled,
          filterable: false,
          "append-to-body": _vm.appendToBody,
        },
        on: {
          input: function ($event) {
            return _setup.onOptionSelected($event)
          },
          open: _setup.dropOpen,
          close: _setup.dropClosed,
          search: _setup.onFontSearch,
        },
        scopedSlots: _vm._u([
          {
            key: "selected-option",
            fn: function ({ label }) {
              return [
                _c(
                  "span",
                  {
                    style: {
                      fontFamily: `'${_setup.generateSafeFontName(
                        label
                      )}', Arial`,
                    },
                  },
                  [_vm._v(_vm._s(label))]
                ),
              ]
            },
          },
          {
            key: "option",
            fn: function (option) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "span",
                      {
                        style: {
                          fontFamily: `'${_setup.generateSafeFontName(
                            option.label
                          )}', Arial`,
                        },
                      },
                      [_vm._v(_vm._s(option.label))]
                    ),
                    _vm._v(" "),
                    option.deletable
                      ? _c(_setup.CButton, {
                          staticClass: "ml-2",
                          attrs: { size: "icon", icon: ["far", "trash-can"] },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.confirmFontDelete(option)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "list-footer",
            fn: function () {
              return [
                _c(
                  "li",
                  {
                    ref: "selectorBottom",
                    staticClass: "p-2 align-items-center",
                    class:
                      _setup.filteredFonts.length == _setup.fontList.length
                        ? "d-none"
                        : "d-flex",
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2 fa-spin",
                      attrs: { icon: ["fas", "spinner-third"] },
                    }),
                    _vm._v("\n                Loading fonts...\n            "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showFontUpload
        ? _c(_setup.CFileInput, {
            attrs: {
              value: [],
              accept: ".ttf,.otf",
              "display-preview": false,
              disabled: _vm.disabled,
            },
            on: { input: _setup.onFontUpload },
            scopedSlots: _vm._u(
              [
                {
                  key: "uploadTrigger",
                  fn: function ({ onFileUpload, disabled: triggerDisabled }) {
                    return [
                      _c(_setup.CButton, {
                        staticClass: "ml-2",
                        attrs: {
                          variant: "secondary",
                          icon: ["far", "arrow-up-from-bracket"],
                          disabled: triggerDisabled,
                        },
                        on: { click: onFileUpload },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              807859707
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }